import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-page-header-title',
	templateUrl: 'page-header-title.component.html',
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class PageHeaderTitleComponent {}
